import { SVSummaryCardItem } from '@/types/common';
import { RecipientRequestDetail } from '@/types/wireRecipients';
import { Typography } from '@mui/material';
import { titleCase } from '@/utils/stringCaser';
import { formatDateTimeFromUTC } from '@/utils/date';
import { SVSummaryCard } from '@/components/core';

type WireRecipientDetailsSubmissionDetailsProps = {
  wireRecipientRequestDetails: RecipientRequestDetail;
};

export default function WireRecipientDetailsSubmissionDetails({
  wireRecipientRequestDetails,
}: WireRecipientDetailsSubmissionDetailsProps) {
  const {
    status,
    requestedAt,
    requestedBy,
    approvedAt,
    approvedBy,
    canceledAt,
    canceledBy,
    declinedAt,
    declinedBy,
  } = wireRecipientRequestDetails;

  const items: SVSummaryCardItem[] = [
    {
      label: 'Status',
      customContent: (
        <Typography
          sx={{
            fontWeight: 'bold',
            color:
              status === 'needs approval'
                ? 'grey'
                : status === 'approved'
                  ? 'success.main'
                  : 'error.main',
          }}>
          {titleCase(status)}
        </Typography>
      ),
    },
    {
      label: 'Requested Date',
      text: formatDateTimeFromUTC(requestedAt, true),
    },
    {
      label: 'Requested By',
      text: `${requestedBy.userName} (${requestedBy.userEmail})`,
    },
    {
      label: 'Approved Date',
      text: formatDateTimeFromUTC(approvedAt, true),
    },
    {
      label: 'Approved By',
      text: approvedBy
        ? `${approvedBy.userName} (${approvedBy.userEmail})`
        : '',
    },
    {
      label: 'Canceled Date',
      text: formatDateTimeFromUTC(canceledAt, true),
    },
    {
      label: 'Canceled By',
      text: canceledBy
        ? `${canceledBy.userName} (${canceledBy.userEmail})`
        : '',
    },
    {
      label: 'Declined Date',
      text: formatDateTimeFromUTC(declinedAt, true),
    },
    {
      label: 'Declined By',
      text: declinedBy
        ? `${declinedBy.userName} (${declinedBy.userEmail})`
        : '',
    },
  ];

  return <SVSummaryCard label="Submission Details" items={items} />;
}
